var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.575 20.118c.571.61.566 1.583-.012 2.187L61.808 40.553c-.28.288-.662.45-1.058.447a1.465 1.465 0 01-1.052-.46L49.432 29.828A1.573 1.573 0 0149 28.732c.002-.41.162-.803.445-1.091l3.53-3.631c.282-.29.662-.45 1.058-.448.396.003.775.168 1.053.46l5.717 5.962 13.168-13.537c.282-.288.662-.45 1.058-.447.396.002.775.168 1.053.46l3.493 3.658z",
    fill: "#ADE422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 32c8.994 0 16.286-7.163 16.286-16S37.494 0 28.5 0c-8.994 0-16.286 7.163-16.286 16S19.506 32 28.5 32zm11.4 4h-2.125a22.508 22.508 0 01-18.55 0H17.1C7.657 36.002.002 43.522 0 52.8V58c0 3.314 2.734 6 6.107 6h44.786C54.266 64 57 61.314 57 58v-5.2c-.002-9.278-7.657-16.798-17.1-16.8z",
    fill: "#E4E9F2"
  }))));
}

export default SvgUserCheck;